export const RUTAS_CONFIRMING = {
  MAPEO_CAMPOS: '/confirming/mapeo-campos',
  CARGA_MASIVA: '/confirming/carga-masiva'
} as const;
